export default __webpack_public_path__ + "static/media/arrow-left.7b3c7f40.svg";